/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Detected_ArchetypeInputs */

const en_deep_match_detected_archetype = /** @type {(inputs: Deep_Match_Detected_ArchetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected Archetype`)
};

const de_deep_match_detected_archetype = /** @type {(inputs: Deep_Match_Detected_ArchetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected Archetype`)
};

const fr_deep_match_detected_archetype = /** @type {(inputs: Deep_Match_Detected_ArchetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected Archetype`)
};

const es_deep_match_detected_archetype = /** @type {(inputs: Deep_Match_Detected_ArchetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected Archetype`)
};

const it_deep_match_detected_archetype = /** @type {(inputs: Deep_Match_Detected_ArchetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected Archetype`)
};

const nl_deep_match_detected_archetype = /** @type {(inputs: Deep_Match_Detected_ArchetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected Archetype`)
};

const pl_deep_match_detected_archetype = /** @type {(inputs: Deep_Match_Detected_ArchetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected Archetype`)
};

const fi_deep_match_detected_archetype = /** @type {(inputs: Deep_Match_Detected_ArchetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected Archetype`)
};

const da_deep_match_detected_archetype = /** @type {(inputs: Deep_Match_Detected_ArchetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected Archetype`)
};

const sv_deep_match_detected_archetype = /** @type {(inputs: Deep_Match_Detected_ArchetypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected Archetype`)
};

/**
* | output |
* | --- |
* | "Detected Archetype" |
*
* @param {Deep_Match_Detected_ArchetypeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_detected_archetype = /** @type {((inputs?: Deep_Match_Detected_ArchetypeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Detected_ArchetypeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_detected_archetype(inputs)
	if (locale === "fr") return fr_deep_match_detected_archetype(inputs)
	if (locale === "es") return es_deep_match_detected_archetype(inputs)
	if (locale === "it") return it_deep_match_detected_archetype(inputs)
	if (locale === "nl") return nl_deep_match_detected_archetype(inputs)
	if (locale === "pl") return pl_deep_match_detected_archetype(inputs)
	if (locale === "fi") return fi_deep_match_detected_archetype(inputs)
	if (locale === "da") return da_deep_match_detected_archetype(inputs)
	if (locale === "sv") return sv_deep_match_detected_archetype(inputs)
	return en_deep_match_detected_archetype(inputs)
});